import React from "react";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import MobileStepper from "@material-ui/core/MobileStepper";
import { withStyles } from "@material-ui/core/styles";
import "./Stepper.css";
import locale from "../../utils/locale";


const styles = theme => ({
  root:{
    marginTop: 20,
    background: "#0A5DB8",
    position: "fixed",
    bottom: 0,
    left: 0,
    width: "100%",
    paddingLeft: 0,
    paddingRight: 0
  },
  dotActive:{
    backgroundColor: "#ffffff"
  },
  buttonDisabled:{ 
    color: "#676767 !important" 
  },
  text:{
    fontSize: 15
  }
})


const Stepper = ({
  totalSteps,
  activeStepIndex,
  onNextClick,
  onBackClick,
  disableNext,
  disableBack,
  classes
}) => (
  <MobileStepper
    variant="dots"
    steps={totalSteps}
    position="static"
    activeStep={activeStepIndex}
    classes={{root: classes.root, dotActive: classes.dotActive}}
    nextButton={
      <Button
        className="btn-nav"
        size="small"
        onClick={() => {
          onNextClick(false);
        }}
        disabled={disableNext}
        classes={{disabled:classes.buttonDisabled, label: classes.text}}
      >
       {activeStepIndex < totalSteps - 1 ? locale("next") : locale("submit")} 
      </Button>     
    }
    backButton={
      <Button
        className="btn-nav"
        size="small"
        onClick={() => {
          onBackClick(false);
        }}
        disabled={disableBack}
        classes={{disabled:classes.buttonDisabled, label: classes.text}}
      >
        {locale("back")}
      </Button>
    }
  />
);

Stepper.propTypes = {
  totalSteps: PropTypes.number,
  activeStepIndex: PropTypes.number,
  onNextClick: PropTypes.func,
  onBackClick: PropTypes.func,
  disableNext: PropTypes.bool,
  disableBack: PropTypes.bool
};

export default withStyles(styles)(Stepper);



// WEBPACK FOOTER //
// ./src/components/Stepper/index.js